import { computed } from "vue";
import { type RouteLocationNormalizedLoaded, useRoute } from "vue-router";
import { Region } from "../graphql";
import { localeOverride } from "../i18n";
import { fromWiRegion } from "./url";

export const absolute = (url: string) => `${window.location.origin}/${url}`;

export const singleRouteParam = (input: string | string[]) => (Array.isArray(input) ? input.join("/") : input);
export const multiRouteParam = (input: string | string[]) => (Array.isArray(input) ? input : [input]);

export const getCurrentRegion = (route: RouteLocationNormalizedLoaded): Region | undefined => {
  if (route.name == "gameserver") {
    const param = singleRouteParam(route.params.region)?.toUpperCase() as Region;
    if (Object.values(Region).includes(param)) return param;
  } else {
    return fromWiRegion(singleRouteParam(route.params.wiRegion)?.toLowerCase());
  }
};

export const cookies = () =>
  new Map(
    document.cookie.split(";").map(function (el) {
      const [k, v] = el.split("=");
      return [k.trim(), v];
    }),
  );

/** The locale as requested by the route (NGP) or the website (WI embedded). */
export const getRouteLocale = (route: RouteLocationNormalizedLoaded): string => {
  if (route?.name == "gameserver") {
    return singleRouteParam(route.params.locale);
  } else {
    return cookies().get("webinterface_locale")?.split("_")[0] || "en";
  }
};

export const getCurrentLocale = (route: RouteLocationNormalizedLoaded): string =>
  // Admins can pin the UI to a specific language via the admin bar
  localeOverride.value || getRouteLocale(route);

export function useRouteUtils() {
  const route = useRoute();

  const region = computed(() => getCurrentRegion(route));
  const locale = computed(() => getCurrentLocale(route));
  const tabSegments = computed(() => multiRouteParam(route.params.tabSegments));

  return { region, locale, tabSegments };
}
